<template>
	<el-cascader v-model="values" :options="region" clearable :separator="cfg.separator" :show-all-levels="cfg.showAllLevels" :props="{emitPath:cfg.emitPath}" @change="changeRegion" :style="{ width: '320px' }"><span slot="empty">加载中……</span></el-cascader>
</template>

<script>
export default {
	name: 'form-item-region',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: Array,
			default: () => {
				return [];
			}
		},
		config: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			cfg: {},
			values: [],
			loading: true,
			selectConfig: {},
			level: 0,
			region: [],
			regionValue: [],
			itemChecked: ''
		};
	},
	beforecreate: function() {},
	created: function() {
	},
	mounted() {
		this.values = this.value;
		this.cfg = this.config;
		this.getRegionData();
	},
	updated: function() {},
	methods: {
		changeRegion(e) {
			console.log(e);
			this.$emit('change', e);
		},
		getRegionData() {
			this.loading = true;
			this.$http.post('/server/index.php?m=components/dataset&a=getData', { id: 'region', deep: this.cfg.deep }).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.region = res.data;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		}
	},
	watch: {
		config: function(val) {
			this.cfg = val;
			console.log(val)
			this.getRegionData();
		}
	}
};
</script>

<style></style>
